import api from "./httpClient";
import { API_PATHS } from "./apiPaths";

const unwrap = (response) => response?.data?.data ?? response?.data ?? response ?? {};

export const recordPublicVisitor = async () => {
  await api.post(API_PATHS.public.visitorHeartbeat(), {}, { skipAuth: true });
};

export const getTodayVisitorStats = async () => {
  const data = unwrap(await api.get(API_PATHS.public.visitorStats(), { skipAuth: true }));
  return {
    visitors: Number(data?.visitors ?? data?.uniqueVisitors ?? 0),
    date: data?.date || "",
  };
};

export const normalizeVisitorAnalytics = (data = {}) => {
  const visitorRecords = data?.visitorRecords ?? data?.visitors ?? data?.visitorDetails ?? data?.records ?? data?.content ?? [];
  return {
    todayVisitors: Number(data?.todayVisitors ?? 0),
    onlineVisitors: Number(data?.onlineVisitors ?? 0),
    onlineLoggedInUsers: Number(data?.onlineLoggedInUsers ?? 0),
    dailyActiveUsers: Number(data?.dailyActiveUsers ?? 0),
    monthlyActiveUsers: Number(data?.monthlyActiveUsers ?? 0),
    currentActiveUsers: Number(data?.currentActiveUsers ?? data?.onlineLoggedInUsers ?? 0),
    dailyVisitors: Array.isArray(data?.dailyVisitors) ? data.dailyVisitors : [],
    liveUsers: Array.isArray(data?.liveUsers) ? data.liveUsers : [],
    visitorRecords: Array.isArray(visitorRecords) ? visitorRecords : [],
    checkedAt: data?.checkedAt || "",
  };
};

export const getSuperAdminVisitorAnalytics = async (days = 7) => {
  const data = unwrap(await api.get(API_PATHS.superAdmin.visitorAnalytics(days), { cache: "no-store" }));
  return normalizeVisitorAnalytics(data);
};

export const normalizeCountryVisitorAnalytics = (data = {}) => ({
  from: data?.from || "",
  to: data?.to || "",
  totalVisitors: Number(data?.totalVisitors ?? 0),
  records: Array.isArray(data?.visitorRecords ?? data?.records) ? (data?.visitorRecords ?? data?.records) : [],
  countries: Array.isArray(data?.countries)
    ? data.countries.map((item) => ({
        country: item?.country || "Unknown",
        visitors: Number(item?.visitors ?? 0),
        visitor_date: item?.visitor_date || item?.visitorDate || "",
        first_seen: item?.first_seen || item?.firstSeen || "",
        last_seen: item?.last_seen || item?.lastSeen || "",
        expires_at: item?.expires_at || item?.expiresAt || "",
      }))
    : [],
});

export const getSuperAdminCountryVisitorAnalytics = async (days = 7) => {
  const data = unwrap(await api.get(API_PATHS.superAdmin.visitorAnalyticsCountries(days), { cache: "no-store" }));
  return normalizeCountryVisitorAnalytics(data);
};

// This audited diagnostic must only be invoked from an explicit Super Admin
// action; never include it in automatic analytics loading or polling.
export const getSuperAdminVisitorLocationDiagnostics = async () =>
  unwrap(await api.get(API_PATHS.superAdmin.visitorAnalyticsCountryDiagnostics(), {
    cache: "no-store",
    withCredentials: true,
  }));
